import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'


/** API */
import FrequenciesAlcoholApi from 'api/setting/default-users/frequencies-alcohol.api'

/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  FREQUENCIES_NAME: ``,
  IS_DUPLICATE_FREQUENCIES_NAME: ``,
  FREQUENCIES_NAME_STRING_BASE: ``,
  FREQUENCIES_NAME_STRING_EMPTY: ``,
  FREQUENCIES_NAME_MAXIMUM_LENGTH: ``,
  FREQUENCIES_NAME_ANY_REQUIRED: ``,

  FREQUENCIES_NAME_EN: ``,
  IS_DUPLICATE_FREQUENCIES_NAME_EN: ``,
  FREQUENCIES_NAME_EN_STRING_BASE: ``,
  FREQUENCIES_NAME_EN_STRING_EMPTY: ``,
  FREQUENCIES_NAME_EN_MAXIMUM_LENGTH: ``,
  FREQUENCIES_NAME_EN_ANY_REQUIRED: ``
}
export default function FrequenciesAlcohols() {

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [frequencice, setFrequencies] = useState([])

  const [frequencyId, setFrequencyId] = useState(Number)
  const [frequencyName, setFrequencyName] = useState('')
  const [frequencyStatus, setFrequencyStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isPopup, setIsPopup] = useState(false)


  const loadData = async () => {
    try {
      const resp = await FrequenciesAlcoholApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setFrequencies(resp.data)
      } else {
        setFrequencies([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const submit = () => {
    if (!frequencyName) return setErrorMessage({ ...errorMessage, ...{ FREQUENCIES_NAME: t('FREQUENCIES_ALCOHOL.MESSAGE.FREQUENCIES_NAME') } })

    dispatch(submitModal())
    setDisabledSubmit(true)
    FrequenciesAlcoholApi.create(frequencyName)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!frequencyName) return setErrorMessage({ ...errorMessage, ...{ FREQUENCIES_NAME: t(`FREQUENCIES_ALCOHOL.MESSAGE.FREQUENCIES_NAME`) } })

    dispatch(submitModal())
    setDisabledSubmit(true)
    FrequenciesAlcoholApi.update(frequencyId, { frequencyName, status: frequencyStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data

          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`FREQUENCIES_ALCOHOL.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }
  const resetForm = () => {
    setFrequencyId(0)
    setFrequencyName('')
    setFrequencyStatus('')
    setIsPopup(false)
    clearErrorMessage()
  }
  const onActive = () => {
    if (id) {
      FrequenciesAlcoholApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      FrequenciesAlcoholApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('FREQUENCIES_ALCOHOL.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { frequencyId: fqcId, frequencyName: fqcName, status: fqcStatus } = data
    setFrequencyId(fqcId)
    setFrequencyName(fqcName)
    setFrequencyStatus(fqcStatus)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'frequencyName', disablePadding: false, label: t('FREQUENCIES_ALCOHOL.TABLE.CELL.FREQUENCIES_NAME') },
    { id: 'status', disablePadding: false, label: t('FREQUENCIES_ALCOHOL.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('FREQUENCIES_ALCOHOL.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { frequencyId: fqcId, frequencyName: fqcName, updatedBy, updatedAt, status: fqcStatus } = objData
    const statusBtnActive = fqcStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = fqcStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: fqcId,
      id: fqcId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: fqcName },
        { option: 'STATUS', align: 'center', label: fqcStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.frequencyName)
    setNameEn(obj.frequencyNameEn)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`FREQUENCIES_ALCOHOL.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`FREQUENCIES_ALCOHOL.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { frequenciesName: name, frequenciesNameEn: nameEn && `(${nameEn})`, status: t(`FREQUENCIES_ALCOHOL.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('FREQUENCIES_ALCOHOL.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('FREQUENCIES_ALCOHOL.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton
                title={t('FREQUENCIES_ALCOHOL.BUTTON.ADD')}
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                onClick={() => setIsPopup(true)}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={frequencice.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
        <PageModal
          title={frequencyId ? t('FREQUENCIES_ALCOHOL.TITLE_UPDATE') : t('FREQUENCIES_ALCOHOL.TITLE_CREATE')}
          isOpen={isPopup}
          onCancel={{ onClick: () => resetForm() }}
          onSubmit={{ onClick: () => frequencyId ? submitEdit() : submit(), disabled: disabledSubmit }}
          handleClose={resetForm}
          size={'XS'}
        >
          <Box style={{ paddingTop: 8, paddingBottom: 8 }}>
            {frequencyId ? (
              <Box display="flex" justifyContent="space-between" alignItems="center" pb={1}>
                <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
                <SwitchButton
                  onChange={() => setFrequencyStatus(frequencyStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                  checked={frequencyStatus === 'ACTIVE'}
                />
              </Box>
            ) : null}

            <TextInput
              fullWidth
              onChange={(event) => {
                setFrequencyName(event.target.value)
                clearErrorMessage()
              }}
              value={frequencyName}
              label={t('FREQUENCIES_ALCOHOL.INPUT.FREQUENCIES_NAME')}
              helperText={
                errorMessage.FREQUENCIES_NAME ||
                errorMessage.IS_DUPLICATE_FREQUENCIES_NAME ||
                errorMessage.FREQUENCIES_NAME_STRING_BASE ||
                errorMessage.FREQUENCIES_NAME_STRING_EMPTY ||
                errorMessage.FREQUENCIES_NAME_MAXIMUM_LENGTH ||
                errorMessage.FREQUENCIES_NAME_ANY_REQUIRED
              }
              required={true}
            />
          </Box>
        </PageModal>
      </Box>
    </Box>
  )
}
